export default [
  {
    title: 'مدیریت خطاها',
    icon: 'bx bx-store',
    children: [
      {
        title: 'خطاها',
        route: { name: 'listErrors' },
        resource: 'ErrorManager',
        action: 'show',
      },
    ],
  },
]
